export default "__VITE_ASSET__pRJgD_xF__"